document.addEventListener("DOMContentLoaded", () => {
    if (window.innerWidth <= 850) {
        const allDesc = document.querySelectorAll(".card-product-3__description");
        const des_card3 = [];
        allDesc.forEach(des=> {
            const ul = des.querySelector("ul");
            if (ul) {
                des_card3.push(ul)
            }
        })
        des_card3.forEach(ul => {
            const lis = ul.querySelectorAll("li");
            if ([...lis].length > 3) {
                const showBtn = ul.closest(".card-product-3__description").querySelector(".show-btn");
                const hiddenLis = [...lis].splice(3);
                console.log(hiddenLis[0])
                // 创建新容器存放切出的li
                const hideUl = document.createElement('ul');
                const hiddenContainer = document.createElement("div");
                hiddenContainer.className = 'hide-container hidden';
                // 将li移动到新容器
                hiddenLis.forEach(li => {
                    hideUl.appendChild(li);
                });
                hiddenContainer.appendChild(hideUl);
                hiddenContainer.appendChild(showBtn);
                // 切换 hiddenContainer 类名并做平滑伸缩
                if (showBtn) {
                    showBtn.addEventListener('click', () => {
                        const hiddenUlEl = hideUl;
                        const isHidden = hiddenContainer.classList.contains('hidden');

                        if (isHidden) {
                            // 展开
                            hiddenContainer.classList.remove('hidden');
                            hiddenContainer.classList.add('show');
                            // 从 0 -> scrollHeight 以实现过渡
                            hiddenUlEl.style.maxHeight = '0px';
                            requestAnimationFrame(() => {
                                hiddenUlEl.style.maxHeight = hiddenUlEl.scrollHeight + 'px';
                            });
                        } else {
                            // 收起：先设置当前高度，再过渡到 0
                            hiddenUlEl.style.maxHeight = hiddenUlEl.scrollHeight + 'px';
                            requestAnimationFrame(() => {
                                hiddenUlEl.style.maxHeight = '0px';
                                hiddenContainer.classList.remove('show');
                                hiddenContainer.classList.add('hidden');
                            });
                        }
                        // 收尾：展开完成后清除 inline maxHeight，允许内容自适应高度变化
                        const onTransitionEnd = (e) => {
                            if (e.propertyName === 'max-height') {
                                if (hiddenContainer.classList.contains('show')) {
                                    hiddenUlEl.style.maxHeight = '';
                                }
                                hiddenUlEl.removeEventListener('transitionend', onTransitionEnd);
                            }
                        };
                        hiddenUlEl.addEventListener('transitionend', onTransitionEnd);
                    });
                }

                // 将新容器插入到ul后面
                ul.parentNode.insertBefore(hiddenContainer, ul.nextSibling);
            }
        })
    }
})


